"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTestId = exports.ComponentDefaultTestId = void 0;
const constants_1 = require("./constants");
exports.ComponentDefaultTestId = constants_1.ComponentDefaultTestId;
const getTestId = (elementType, id) => {
    return id ? `${elementType}_${id}` : elementType;
};
exports.getTestId = getTestId;
